import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';


// ui components 
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

// icons
import Check from "@material-ui/icons/Check";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// services
import { UseGetApiSimple, UseGetApiendPointDiferent, UsePostApi, UsePutApi, } from "beaktShared/services/crudeApiService";
import { MaskDate, formateDate, validateDate, convertDate, MaskCPF, MaskCEP, MaskRG, MaskCel, MaskMoney } from "beaktShared/helpers/masks";
import moment from "moment";
import { SessionContext } from "beaktShared/services/session";
import Select from 'react-select';

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function GestaoClienteForm({ 
        addItem, 
        item, 
        handleView, 
        estabelecimentoId, 
        disabledNOME, 
        disabledCPF, 
        disabledEMAIL, 
        verificaVendaEmProcessamento = false,
        verifyClientVendaEmProcessamento }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, handleSubmit, setValue, setError, errors, clearError, getValues } = useForm({ mode: "onBlur" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
    const [DisabledNome, setDisabledNome] = React.useState(false);
    const [DisabledCPF, setDisabledCPF] = React.useState(false);
    const [DisabledEMAIL, setDisabledEMAIL] = React.useState(false);
    const [celularTemWhatsApp, setCelularTemWhatsApp] = React.useState(false);

    const intialValues = {
        id: 0,
        cpf: '',
        rg: '',
        nome: '',
        ativo: false,
        dataNascimento: '',
        email: '',
        celular: '',
        linkFacebook: '',
        linkInstagram: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        usuarioId: 0,
        profissaoId: 0,
        celularTemWhatsApp: false,
        rendaMensal: ''
    };

    const [profissao, setProfissao] = React.useState("");
    const [listSelectProfissao, setListSelectProfissao] = React.useState([]);
    const [loadingSelectProfissao, setloadingSelectProfissao] = React.useState(false);
    const handleProfissaoChange = event => {
        let value = event
        setProfissao(value);
        setValue("profissao", value);
        if (value !== "")
            clearError("profissao");
    };
    const getEndPoint = () => {
        let endPointGet = "";
        endPointGet = "profissao/ativos/byestabelecimento/" + session.estabelecimentoId;
        return endPointGet;
    }
    const LoadSelectProfissoes = () => {
        setloadingSelectProfissao(true);
        const endPoint = getEndPoint();
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectProfissao(false);
                return false;
            }
            setListSelectProfissao(result.data);
            setloadingSelectProfissao(false);

            return true;
        });
    }

    const [loadingCep, setloadingCep] = React.useState(false);
    const handleCEPBlur = (e) => {
        let cep = e.target.value;
        if (cep === "")
            return;
        cep = cep.replace("-", "");

        setloadingCep(true);
        const endPoint = "https://viacep.com.br/ws/" + cep + "/json";
        UseGetApiendPointDiferent(endPoint).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setloadingCep(false);
                return false;
            }
            let resultcep = result.data;
            setValue('rua', resultcep.logradouro);
            setValue('complemento', resultcep.complemento);
            setValue('bairro', resultcep.bairro);
            setValue('cidade', resultcep.localidade);
            setValue('estado', resultcep.uf);
            setloadingCep(false);
        });
    };

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
    const [validateCPF, setvalidateCPF] = React.useState(false);
    const handleCPFChange = e => {
        let cpf = e.target.value;
        if (cpf === "")
            return;
        if (cpf.length < 14)
            return;

        let data = getValues()

        setloadingValidateCPF(true);
        const endPoint = "clientes/vefifycpf/" + cpf + "/" + parseInt(data.id);
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setloadingValidateCPF(false);
                return false;
            }
            setvalidateCPF(result.data);
            if (result.data)
                setError("cpf", "invalidcpf", t('error_message.cpf_already_existing') + ".")
            else
                clearError("cpf");
            setloadingValidateCPF(false);
        });
    }

    const [sexo, setSexo] = React.useState("");
    const handleSexoChange = event => {
        setSexo(event.target.value);
        setValue("sexo", event.target.value);
        if (event.target.value !== "")
            clearError("sexo");
    };

    useEffect(() => {
        LoadDadosItem(item);
        LoadSelectProfissoes();
    }, [item]);

    const LoadDadosItem = (item) => {
        if (item !== null) {
            setValue('cpf', item.cpf);
            setValue('email', item.email);

            if (session.tipoPerfil != 0 && session.tipoPerfil != 4) {
                if (disabledNOME && item.nome != "") {
                    setDisabledNome(true);
                }
                if (disabledCPF && item.cpf != "") {
                    setDisabledCPF(true);
                }
                if (disabledEMAIL && item.email != "") {
                    setDisabledEMAIL(true);
                }
            }
        }
        if (!item.clienteId)
            return;

        setValue('id', item.clienteId);
        setValue('usuarioId', item.usuarioId);
        setValue('nome', item.nome);
        setAtivoCheckbox(item.ativo);
        setValue('rg', item.rg);
        setValue('profissao', item.profissaoId);
        setProfissao(item.profissaoId);
        setCelularTemWhatsApp(item?.celularTemWhatsApp);

        var dtnasc = "";
        if (item.dataNascimento !== null)
            dtnasc = formateDate(item.dataNascimento);

        setValue('dataNascimento', dtnasc);
        if (item.sexo !== null) {
            setSexo(item.sexo);
            setValue("sexo", item.sexo);
        }
        setValue('email', item.email);
        setValue('celular', item.celular);
        setValue('linkFacebook', item.linkFacebook);
        setValue('linkInstagram', item.linkInstagram);
        setValue('rua', item.rua);
        setValue('numero', item.numero);
        setValue('complemento', item.complemento);
        setValue('bairro', item.bairro);
        setValue('cidade', item.cidade);
        setValue('estado', item.estado);
        setValue('cep', item.cep);
        setValue('rendaMensal', item?.rendaMensal?.toFixed(2).replace('.',',') ?? '');
    };

    const [loading, setLoading] = React.useState(false);
    const onSubmit = async (data, e) => {
        e.preventDefault();

        // Valida se foi chamada pela tela de identificação de venda
        if (verificaVendaEmProcessamento) {
            const result = await verifyClientVendaEmProcessamento(item.clienteId);
            if (result) {
                return;
            }
        }
        
        if (validateCPF) {
            return setError("cpf", "invalidcpf", t('error_message.cpf_already_existing') + ".")
        }

        var dataNasC = "";
        if (data.dataNascimento !== "") {
            if (!validateDate(data.dataNascimento)) {
                return setError("dataNascimento", "invaliddate", t('error_message.invalid_date'))
            }
            var dataNasC = convertDate(data.dataNascimento);
        }

        let sexoE = parseInt(data.sexo);
        if (isNaN(sexoE))
            sexoE = null;

        var cliente = {
            clienteId: parseInt(data.id),
            nome: data.nome,
            ativo: data.ativo,
            cpf: data.cpf,
            rg: data.rg,
            dataNascimento: dataNasC,
            sexo: sexoE,
            email: data.email,
            celular: data.celular,
            linkFacebook: data.linkFacebook,
            linkInstagram: data.linkInstagram,
            rua: data.rua,
            numero: data.numero,
            bairro: data.bairro,
            complemento: data.complemento,
            cidade: data.cidade,
            estado: data.estado,
            cep: data.cep,
            usuarioCadastroId: session.id,
            usuarioId: parseInt(data.usuarioId),
            profissaoId: data.profissao,
            celularTemWhatsApp: data.celularTemWhatsApp,
            rendaMensal: data?.rendaMensal ? parseFloat(
                data.rendaMensal
                    .toString()
                    .replace(/\./g, '')
                    .replace(',', '.')
                ) : null,
        };

        var estabelecimentoClientes = [
            {
                clienteId: item.clienteId,
                estabelecimentoId: estabelecimentoId
            }
        ];
        var cliente = { ...cliente, estabelecimentoClientes };

        var verifyInsert = false;
        if (cliente.clienteId === 0)
            verifyInsert = true;

        const endPoint = 'clientes/';
        if (!verifyInsert) {
            setLoading(true);
            UsePutApi(endPoint, cliente.clienteId, cliente).then(result => {
                if (result.status !== 200) {
                    let errorMessage = '';
                    if (typeof result.message === 'string') {
                        errorMessage = result.message;
                    } else if (result.message?.message) {
                        errorMessage = result.message.message;
                    } else if (result.message?.error) {
                        errorMessage = result.message.error;
                    } else {
                        errorMessage = 'Erro inesperado ao processar a requisição.';
                    }
                    showNotification(errorMessage, 'danger');
                    setLoading(false);
                    return false;
                }
                addItem(cliente);
                setLoading(false);
                showNotification(result.message, 'success');
                return true;
            });
        }
        else {
            setLoading(true);
            UsePostApi(endPoint, cliente).then(result => {
                if (result.status !== 201) {
                    let errorMessage = '';
                    if (typeof result.message === 'string') {
                        errorMessage = result.message;
                    } else if (result.message?.message) {
                        errorMessage = result.message.message;
                    } else if (result.message?.error) {
                        errorMessage = result.message.error;
                    } else {
                        errorMessage = 'Erro inesperado ao processar a requisição.';
                    }
                    showNotification(errorMessage, 'danger');
                    setLoading(false);
                    return false;
                }
                addItem(result.data);
                setLoading(false);
                showNotification(result.message, 'success');
                return true;

            });
        }
    };

    const handleViewForm = () => {
        handleView(true);
    };

    return (
        <div >
            <form onSubmit={handleSubmit(onSubmit)}>
                <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                <input className={classes.hidden} defaultValue={intialValues.usuarioId} name="usuarioId" ref={register} />

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('sidebar.personal_information')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                disabled={DisabledCPF}
                                error={errors.cpf ? true : false}
                                label="CPF"
                                variant="outlined"
                                onChange={handleCPFChange}
                                inputRef={register({ required: false })}
                                name="cpf"
                                defaultValue={intialValues.cpf}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskCPF,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errors.cpf &&
                                <FormHelperText className={classes.labelRootError}>
                                    <span>{errors.cpf.message} </span>
                                </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.rg ? true : false}
                                label="RG"
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="rg"
                                defaultValue={intialValues.rg}
                                InputLabelProps={{ shrink: true }}
                            />
                            {errors.rg && <FormHelperText className={classes.labelRootError}>
                                <span>{errors.rg.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                disabled={DisabledNome}
                                error={errors.nome ? true : false}
                                label={t('label.name') + " *"}
                                variant="outlined"
                                inputRef={register({ required: true })}
                                name="nome"
                                defaultValue={intialValues.nome}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                            {errors.nome && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    {listSelectProfissao.filter((profissao) => profissao.ativo === true).length > 0 && 
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.profissao ? "select__label select__label_error" : "select__label"}>
                                {t('label.profession')} *
                            </label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.profissao ? true : false)}
                                isSearchable={true}
                                isLoading={loadingSelectProfissao}
                                name="profissao"
                                placeholder={t('label.select') + " ..."}
                                options={listSelectProfissao}
                                value={listSelectProfissao.find(({ profissaoId }) => profissaoId === profissao)}
                                getOptionLabel={({ descricao }) => descricao}
                                getOptionValue={({ profissaoId }) => profissaoId}
                                onChange={(value) => {
                                const selectedValue = value?.profissaoId || "";
                                setProfissao(selectedValue);
                                setValue("profissao", selectedValue);
                                }}
                            />

                            <input
                                type="hidden"
                                name="profissao"
                                value={profissao || ""}
                                ref={register({ required: true })}
                            />

                            <FormHelperText className={classes.labelRootError}>
                                {errors.profissao && <span>{t('label.required')}</span>}
                            </FormHelperText>
                        </FormControl>

                    </GridItem>}
                    <GridItem xs={12} sm={6} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.sexo ? true : false}
                                select
                                variant="outlined"
                                label={t('label.gender')}
                                value={sexo}
                                onChange={handleSexoChange}
                                name="sexo"
                                ref={() => register({ name: "sexo" })}
                                InputLabelProps={{ shrink: true }}
                            >
                                <MenuItem value="0">
                                    {t('label.female')}
                                </MenuItem>
                                <MenuItem value="1">
                                    {t('label.male')}
                                </MenuItem>
                            </TextField>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.dataNascimento ? true : false}
                                label={t('label.date_of_birth')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="dataNascimento"
                                defaultValue={intialValues.dataNascimento}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskDate,
                                }}
                            />
                            {errors.dataNascimento && <FormHelperText className={classes.labelRootError}>
                                <span>{errors.dataNascimento.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('sidebar.contact_information')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                disabled={DisabledEMAIL}
                                error={errors.email ? true : false}
                                label={t('label.email') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                    pattern: {
                                        value: /^\S+@\S+$/i,
                                        message: t('label.invalid_email')
                                    },
                                    maxLength: {
                                        value: 50,
                                        message: t('label.enter_a_maximum_of_50_characters')
                                    }
                                })}
                                name="email"
                                defaultValue={intialValues.email}
                                InputLabelProps={{ shrink: true }}
                            />
                            {errors.email && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.email.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    checked={ativoCheckbox}
                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                    name="ativo"
                                    inputRef={register}
                                />
                            }
                            classes={{
                                label: classes.label,
                                root: classes.labelRoot
                            }}
                            label={t('information_message.system_active') + "?"}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.celular ? true : false}
                                label={t('label.cell_phone')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="celular"
                                defaultValue={intialValues.celular}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskCel,
                                    required: true
                                }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={8}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    checked={celularTemWhatsApp}
                                    onClick={event => { setCelularTemWhatsApp(event.target.checked) }}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                    name="celularTemWhatsApp"
                                    inputRef={register}
                                />
                            }
                            classes={{
                                label: classes.label,
                                root: classes.labelRoot
                            }}
                            label={t('information_message.phone_reachable_by_WhatsApp') + "?"}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.linkFacebook ? true : false}
                                label={t('label.facebook')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="linkFacebook"
                                defaultValue={intialValues.linkFacebook}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.linkInstagram ? true : false}
                                label={t('label.instagram')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="linkInstagram"
                                defaultValue={intialValues.linkInstagram}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('sidebar.financial_information')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                label={t('label.monthly_income')}
                                variant="outlined"
                                InputLabelProps={{shrink: true}} 
                                defaultValue={intialValues.rendaMensal} 
                                inputRef={register({ required: false })}
                                name="rendaMensal"              
                                InputProps={{ inputComponent: MaskMoney}}
                                error={errors.valor?true:false} 
                                inputProps={{ maxLength: 15 }}
                            />
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('sidebar.addres_information')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.cep ? true : false}
                                label={t('label.cep') + " *"}
                                onBlur={handleCEPBlur}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="cep"
                                defaultValue={intialValues.cep}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 10 }}
                                InputProps={{
                                    inputComponent: MaskCEP,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {loadingCep && <LoadingIcon className="rotate" />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={7}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.rua ? true : false}
                                label={t('label.street') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="rua"
                                defaultValue={intialValues.rua}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.numero ? true : false}
                                label={t('label.number') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="numero"
                                defaultValue={intialValues.numero}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 8 }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.complemento ? true : false}
                                label={t('label.complement')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="complemento"
                                defaultValue={intialValues.complemento}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 30 }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.bairro ? true : false}
                                label={t('label.neighborhood') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="bairro"
                                defaultValue={intialValues.bairro}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.cidade ? true : false}
                                label={t('label.city') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="cidade"
                                defaultValue={intialValues.cidade}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={1}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.estado ? true : false}
                                label={t('label.state') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="estado"
                                defaultValue={intialValues.estado}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 2 }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <Clearfix />
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter} style={{ marginTop: 10 }}>
                        {handleView !== null && <Button onClick={() => handleViewForm()} color="transparent" >
                            {t('label.return')}
                        </Button>
                        }
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')}
                            {loading && <div> ...{t('label.loading')} </div>}
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />

        </div>
    );
}